export default {"src":"/_next/static/media/bug_fixing.cc4016a1.svg","height":786,"width":1023,"blurWidth":0,"blurHeight":0};